import {
  LANGUAGE_ENUMS,
  domainCode,
} from '../../../constants/staticPageConstants';
import { DotComMobileNavbar } from '../DotComHeader';
import { TDropdownList } from '../DynamicHeader/Dropdown/DropdownComponent';
import { HEADER_LABELS } from '../DynamicHeader/Dropdown/DropdownData';
import {
  ABOUT_US,
  CONTACT_US_PAGE,
  SOLUTIONS,
} from '../DynamicHeader/Dropdown/DropdownDataFrCommon';

interface IProps {
  language: LANGUAGE_ENUMS;
  LangSwitchLink?: TDropdownList;
  domain: number;
}

const MobileNavBar = ({
  language = LANGUAGE_ENUMS.English,
  LangSwitchLink,
  domain,
}: IProps): JSX.Element => {
  const header_labels = HEADER_LABELS[language as keyof typeof HEADER_LABELS];

  const direction = language === LANGUAGE_ENUMS.Arabic ? 'rtl' : 'ltr';

  const mobileDropdownProps = [];
  if (domain == domainCode.cleartaxMY) {
    mobileDropdownProps.push({
      dropdownLabel: header_labels.about_us,
      dropdownList: ABOUT_US[domain],
    });
  } else {
    mobileDropdownProps.push(
      {
        dropdownLabel: header_labels.about_us,
        dropdownList: ABOUT_US[domain],
      },
      {
        dropdownLabel: header_labels.solutions,
        dropdownList: SOLUTIONS[domain],
      }
    );
  }

  return (
    <>
      <DotComMobileNavbar
        direction={direction}
        domain={domain}
        language={language}
        header_labels={header_labels}
        LangSwitchLink={LangSwitchLink}
        mobileDropdownProps={mobileDropdownProps}
        contact_us_page={CONTACT_US_PAGE[domain]}
      />
    </>
  );
};

export { MobileNavBar };
